// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".scm-dialog .el-dialog__body {\n  padding: 10px 40px;\n}\n.scm-dialog .el-dialog__footer {\n  padding: 10px 20px;\n}\n.scm-dialog .scm-dialog-cancel:hover {\n  background-color: #e6f8f2;\n  color: #00bb7c;\n  border: 1px solid #b3ebd8;\n}\n.scm-dialog .scm-dialog-submit:hover {\n  background-color: #33c996 !important;\n  border: 1px solid #33c996 !important;\n}", ""]);
// Exports
module.exports = exports;
